// extracted by css-extract-rspack-plugin
export default {"downloadBtn":"L2jW9UZSmsoGjU4J"};